<app-page-header subtitle="Projecten">
    <div class="d-flex align-items-center" filters>
        <button (click)="openProjectEditDialog()" mat-raised-button>Project toevoegen</button>
    </div>
</app-page-header>
<div class="text-container">
    <div class="row justify-content-center">
        <div class="col-md-8">
            <mat-form-field class="w-100" appearance="fill">
                <mat-label>Project</mat-label>
                <input [formControl]="fcProjectSearch" matInput placeholder="Project (naam, nummer, locatie)" />
            </mat-form-field>
        </div>
        <div class="col-md-8">
            <ng-select
                class="w-100 ng-select-fill"
                [formControl]="fcUserFilter"
                [placeholder]="environment.executorName | ucFirst"
                [clearable]="true"
                bindLabel="name"
                bindValue="id">
                @for (user of executorMap; track user) {
                    <ng-option [value]="user.id">
                        {{ user.name }}
                    </ng-option>
                }
            </ng-select>
        </div>
        <div class="col-md-8">
            <ng-select
                class="w-100 ng-select-fill"
                [formControl]="fcProjectManagerFilter"
                [clearable]="true"
                placeholder="Projectleider"
                bindLabel="name"
                bindValue="id">
                @for (user of projectmanagerMap; track user) {
                    <ng-option [value]="user.id">
                        {{ user.name }}
                    </ng-option>
                }
            </ng-select>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <table class="table table-hover">
                <tr>
                    <th>Nummer</th>
                    <th>Naam</th>
                    @if (environment.subProjects) {
                        <th>Hoofdproject</th>
                    }
                    <th>Status</th>
                    <th>Projectleider</th>
                    <th>
                        {{ environment.executorName | ucFirst }}
                    </th>
                    <th>Asfaltuitvoerder</th>
                    <th>Locatie</th>
                    @if (Functionalities.Report | hasFunctionality) {
                        <th style="width: 40px">Dag</th>
                    }
                    @if (Functionalities.Weekreports | hasFunctionality) {
                        <th style="width: 40px">Week</th>
                    }
                    @if (Functionalities.PeriodSettlementExecution | hasFunctionality) {
                        <th style="width: 40px">Afas</th>
                    }
                </tr>
                @if (!usersLoaded) {
                    <tr>
                        <td class="text-center p-4" [attr.colspan]="environment.subProjects ? 8 : 7">
                            <div class="d-flex align-items-center justify-content-center">
                                <mat-spinner class="me-2" diameter="30"></mat-spinner>
                                <span>Gebruikers laden...</span>
                            </div>
                        </td>
                    </tr>
                }
                @if (usersLoaded && filteredProjects.length === 0) {
                    <tr>
                        <td class="text-center p-4" [attr.colspan]="environment.subProjects ? 8 : 7">
                            <span class="text-muted">Geen projecten gevonden met de huidige filters.</span>
                        </td>
                    </tr>
                }
                @for (project of filteredProjects; track project.afas_project_id) {
                    <tr
                        class="curpoint"
                        [class.status-closed]="project.status | projectStatus"
                        (click)="openProjectEditDialog(project.afas_project_id)">
                        <td>
                            @if (project.status | projectStatus) {
                                <i class="fa fa-lock"></i>
                            }
                            {{ project.afas_project_id }}
                        </td>
                        <td>
                            {{ project.name }}
                        </td>
                        @if (environment.subProjects) {
                            <td>
                                {{ project.parent_id }}
                                <button
                                    (click)="$event.stopPropagation(); openProjectEditDialog(null, project.parent_id)"
                                    mat-icon-button
                                    color="primary">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </td>
                        }
                        <td>
                            {{ project.status_name }}
                        </td>
                        <td>
                            {{ project.projectmanager?.name || '-' }}
                        </td>
                        <td>
                            {{ project.performer?.name || '-' }}
                        </td>
                        <td>
                            {{ project.asphalt_performer?.name || '-' }}
                        </td>
                        <td>
                            {{ project.location }}
                        </td>
                        @if (Functionalities.Report | hasFunctionality) {
                            <td class="button" (click)="$event.stopPropagation(); goToDayReport(project)">
                                <i class="far fa-calendar-day"></i>
                            </td>
                        }
                        @if (Functionalities.Weekreports | hasFunctionality) {
                            <td class="button" (click)="$event.stopPropagation(); goToWeekReport(project)">
                                <i class="far fa-calendar-week"></i>
                            </td>
                        }
                        @if (Functionalities.PeriodSettlementExecution | hasFunctionality) {
                            <td class="button" (click)="$event.stopPropagation(); goToSettlements(project)">
                                <i class="far fa-file-invoice-dollar"></i>
                            </td>
                        }
                    </tr>
                }
            </table>
        </div>
    </div>
</div>
